import React, { useEffect, useRef, useState } from "react";
import Product from "./productListcomponents/Product";
import { generatePDF } from "../utils/productcompare";
import { showErrorToast } from "../utils/toaster";

function ProductComparison({ data }) {


  const products = Array.isArray(data.products) ? data.products : [];

  //  console.log("🧪 Seller of first product:", products[0]?.seller);
  console.log("📦 ProductComparison received data:", data);
  const [featureColumnWidth, setFeatureColumnWidth] = useState(0);
  const featureColumnRef = useRef(null);

  useEffect(() => {
    if (featureColumnRef.current) {
      const width = featureColumnRef.current.offsetWidth;
      setFeatureColumnWidth(width);
    }
  }, []);

  // const onClickcompareProduct = async (productsToCompare) => {
  //   if (Array.isArray(productsToCompare) && productsToCompare.length > 0) {
  //     const updatedProducts = productsToCompare.map((product) => {
  //       let updatedProduct = { ...product };
  //       if (product.image && product.image.contentType && product.image.data) {
  //         // updatedProduct.image = `data:${product.image.contentType};base64,${product.image.data}`;
  //         updatedProduct.image = await convertImageToBase64(product.image);

  //           console.log("✅ Updated image for PDF:", updatedProduct.image);

  //       } else {
  //         updatedProduct.image = null; // Or assign a placeholder image path
  //       }
  //       return updatedProduct;
  //     });

  //     generatePDF(updatedProducts);
  //   } else {
  //     showErrorToast("You must provide at least one product to compare.");
  //   }
  // };

  const onClickcompareProduct = async (productsToCompare) => {
    if (Array.isArray(productsToCompare) && productsToCompare.length > 0) {
      const updatedProducts = await Promise.all(
        productsToCompare.map(async (product, index) => {
          const updatedProduct = { ...product };

          console.log(`🔍 [${index + 1}] Original image:`, product.image);

          if (
            typeof product.image === "string" ||
            (product.image && product.image.contentType && product.image.data)
          ) {
            updatedProduct.image = await convertImageToBase64(product.image);

            console.log(`✅ [${index + 1}] Converted base64 image:`, updatedProduct.image?.substring(0, 100) + "...");
          } else {
            updatedProduct.image = null;
            console.warn(`⚠️ [${index + 1}] No valid image to convert.`);
          }

          return updatedProduct;
        })
      );

      generatePDF(updatedProducts);
    } else {
      showErrorToast("You must provide at least one product to compare.");
    }
  };



  const gridCols =
    products.length === 4
      ? "grid-cols-4"
      : products.length === 3
        ? "grid-cols-3"
        : products.length === 2
          ? "grid-cols-2"
          : "grid-cols-1";



  const convertImageToBase64 = async (url) => {
    if (!url || typeof url !== "string") return null;

    // If already in base64 format, return as is
    if (url.startsWith("data:image")) return url;

    try {
      const response = await fetch(url);
      const blob = await response.blob();

      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob); // Converts to base64
      });
    } catch (err) {
      console.error("Image conversion failed for URL:", url);
      return null;
    }
  };


  return (
    <div>
      {/* Header Section */}
      <div className="mb-8 text-center ">
        <p className="text-2xl font-bold text-gray-800 mb-4">
          Compare with similar items
        </p>
      </div>

      <div className="mt-20">
        {/* Products Section */}
        <div
          className={`grid overflow-x-auto ${gridCols} gap-8 mb-8 pl-[150px]`}
        >
          {products.map((product) => (
            <Product key={product._id} product={product} />
          ))}
        </div>

        {/* Comparison Table Section */}
        <div
          // onClick={() => onClickcompareProduct(data)}
          onClick={() => onClickcompareProduct(products)}

          className="mb-3 cursor-pointer text-right text-indigo-600 hover:text-indigo-800 underline font-semibold text-sm transition duration-300 ease-in-out mt-20"
        >
          Download Comparison
        </div>
        <div className="overflow-x-auto shadow-lg rounded-lg bg-white">
          <table className="table-auto w-full border-collapse text-left text-sm">
            <thead className="bg-indigo-600 text-white">
              <tr>
                {/* Fixed width for Feature column */}
                <th className="border border-gray-300 px-6 py-3 font-semibold w-[150px]">
                  Feature
                </th>

                {/* Dynamically distribute the rest of the columns equally */}
                {products.map((product, index) => (
                  <th
                    key={product._id}
                    className="border border-gray-300 px-6 py-3 font-semibold"
                    style={{ width: `${100 / products.length}%` }}
                  >
                    {product.name}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {[
                ["Description", ...products.map((p) => p.description)],
                ["Price", ...products.map((p) => `Rs. ${p.price}`)],
                ["Size", ...products.map((p) => p.size)],
                ["Category", ...products.map((p) => typeof p.category === "object" ? p.category?.name || "N/A" : p.category)],
                ["Subcategory", ...products.map((p) => typeof p.subcategory === "object" ? p.subcategory?.name || "N/A" : p.subcategory)],

                // ["Seller", ...products.map((p) => {
                //   if (!p.seller) return "Not Available";
                //   if (typeof p.seller === "string") return "Seller ID"; // fallback
                //   if (typeof p.seller === "object") return p.seller.name || "Unnamed Seller";
                //   return "Not Available";
                // })],
                ["Seller", ...products.map((p) => {
                  if (!p.seller) return "Not Available";
                  if (typeof p.seller === "string") return "Seller ID"; // fallback
                  if (typeof p.seller === "object") return p.seller.companyName || "Unnamed Company";
                  return "Not Available";
                })],

                ,
                [
                  "Specifications",
                  ...products.map((p) =>
                    p.specifications.length
                      ? p.specifications
                        .map((spec) => `${spec.key}: ${spec.value}`)
                        .join(", ")
                      : "Not Available"
                  ),
                ],
                ["Total Ratings", ...products.map((p) => p.totalratings)],
              ].map((row, index) => {


                return (
                  <tr key={index} className="bg-white hover:bg-gray-50">
                    {row.map((cell, cellIndex) => {
                      return (
                        <td
                          key={cellIndex}
                          className={`border border-gray-300 px-6 py-3 ${cellIndex === 0 ? "font-medium text-gray-700" : ""
                            }`}
                        >
                          {cell}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ProductComparison;
